$(function(){

  // スクロールでヘッダー固定
  {
    // スクロールイベント軽減のフラグ
    let flug = true;
    $(window).scroll(function(){
      if(flug){
        flug = false;
        setTimeout(function(){

          // メニューボタンの要素
          const $menu_btn = $(".add_header__menu");

          const scrollAmount = $(window).scrollTop();
          const $addHeader = $('.add_header');
          const $addHeaderBox = $('.add_header__box');

          // ヘッダーメニューが固定されていないときに実行
          if(!$menu_btn.hasClass("add_header__menu_open")){

            if(scrollAmount > 100 && !$addHeader.hasClass("add_header_fixed-flag")){
              $addHeader.addClass('add_header_fixed-flag');
              $addHeader.animate({opacity: 0}, function() {
                $addHeaderBox.css({height: $addHeader.height()});
                $addHeader.addClass('add_header_fixed');
              }).animate({opacity: 1});
            }
            else if(scrollAmount < 100 && $addHeader.hasClass("add_header_fixed-flag")){
              $addHeader.removeClass('add_header_fixed-flag');
              $addHeader.animate({opacity: 0}, function() {
                $addHeader.removeClass('add_header_fixed');
                $addHeaderBox.css({height: 0});
              }).animate({opacity: 1});
            }

          }  

          flug = true;
          return flug;
        }, 100);
      }
    });
  }

  // メニューの開閉
  {
    const $menu_btn = $(".add_header__menu");
    const $menu = $(".add_menu");
    $menu_btn.click(function() {
      
      // ヘッダーの要素
      const $addHeader = $('.add_header');
      const $addHeaderBox = $('.add_header__box');
      
      if($menu_btn.hasClass("add_header__menu_open")){
        $menu_btn.removeClass("add_header__menu_open");
        $menu.fadeOut();
        
        // メニューが固定されていなかったら元の位置に戻す
        if(!$addHeader.hasClass("add_header_fixed-flag")){
          $addHeader.animate({opacity: 0}, function() {
            $addHeader.removeClass('add_header_fixed');
            $addHeaderBox.css({height: 0});
          }).animate({opacity: 1});
        }
      }
      else{
        $menu_btn.addClass("add_header__menu_open");
        setTimeout(function(){
          $menu.fadeIn();
        },250);
        
        // メニューが固定されていなかったら上部に固定する
        if(!$addHeader.hasClass("add_header_fixed-flag")){
          $addHeader.animate({opacity: 0}, function() {
            $addHeaderBox.css({height: $addHeader.height()});
            $addHeader.addClass('add_header_fixed');
          }).animate({opacity: 1});
        }
      }
    });
  }

  // スクロールで固定ボタン表示
  {
    // スクロールイベント軽減のフラグ
    let flug = true;
    $(window).scroll(function(){
      if(flug){
        flug = false;
        setTimeout(function(){  

          const scrollAmount = $(window).scrollTop();
          const $fixed = $(".add_fixed");

          if(scrollAmount > 600 && !$fixed.hasClass("add_fixed_show")){
            $fixed.addClass("add_fixed_show");
          }
          else if(scrollAmount < 600 && $fixed.hasClass("add_fixed_show")){
            $fixed.removeClass("add_fixed_show");
          }

          flug = true;
          return flug;
        }, 100);
      }
    });
  }

  // スライダー
  {
    const w = window.innerWidth;
    let slide_count;
    if(w > 768){
      slide_count = w / 500;
    }
    else{
      slide_count = w / 335;
    }
    
    
    const swiper = new Swiper(".add_slider__swiper", {
      // ページネーションが必要なら追加
      pagination: {
        el: ".swiper-pagination",
      },
      centeredSlides: true,
      slidesPerView: slide_count, // 画面幅で画像幅変更
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }

  // よくある質問
  {
    const $item = $(".add_faq__q");
    $item.click(function() {
      const $this = $(this);
      if($this.hasClass("add_faq__q_open")){
        $this.removeClass("add_faq__q_open");
        $this.siblings(".add_faq__a").slideUp();
      }
      else{
        $this.addClass("add_faq__q_open");
        $this.siblings(".add_faq__a").slideDown();
      }
    });
  }

  // お気に入り登録ボタンのスタイル変更
  {
    // URLから商品IDを取得
    const productId = window.location.pathname.split('/').pop();

    // ローカルストレージからウィッシュリストを取得
    const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    // ウィッシュリストに商品IDが含まれている場合、ボタンにクラスを追加
    if (wishlist.includes(productId)) {
      $('.add_product_wish').addClass('add_product_wish_disabled');
      $('.add_product_wish').find(".add_product_wish__text").text("お気に入り解除");
    }

    // クリックイベントハンドラー
    $('.add_product_wish').click(function() {
      // ウィッシュリストの更新
      const index = wishlist.indexOf(productId);
      if (index === -1) {
        // 商品IDがウィッシュリストにない場合、追加
        wishlist.push(productId);
        $(this).addClass('add_product_wish_disabled');
        $(this).find(".add_product_wish__text").text("お気に入り解除");
      } else {
        // 商品IDがウィッシュリストにある場合、削除
        wishlist.splice(index, 1);
        $(this).removeClass('add_product_wish_disabled');
        $(this).find(".add_product_wish__text").text("お気に入り登録");
      }

      // 更新されたウィッシュリストをローカルストレージに保存
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    });
  }

  // 商品ページのLine item propertyの動作
  {
    // form内のpropertyに値を入力
    change_check_box("property_gift_wrapping");
    change_check_box("property_message_cart");
    input_textarea("property_message_cart_text");
    change_check_box("property_board");
    input_textarea("property_board_text");

    // 対応するテキストエリアを表示
    show_textarea("property_message_cart");
    show_textarea("property_board");

    // 対応するform内のpropertyに値を入力する関数（チェックボックス）
    function change_check_box(this_elm_name){
      $("."+this_elm_name).change(function() {
        const $this = $(this);
        const $this_property = $("#"+this_elm_name);
        if($this.is(":checked")){
          $this_property.prop("checked", true);
        }
        else{
          $this_property.prop("checked", false);
        }
      });

    }

    // 対応するform内のpropertyに値を入力する関数（テキストエリア）
    function input_textarea(this_elm_name){
      $("."+this_elm_name).on("input",function(){
        const $this = $(this);
        $("#"+this_elm_name).val($this.val());
      }); 
    }

    // 対応するテキストボックスを表示/非表示
    function show_textarea(this_elm_name){
      const $this_elm = $("."+this_elm_name);

      // ページロード時の挙動
      $(window).on('load', function (){
        this_func($this_elm);
      });

      // チェックボックス変更時の挙動
      $this_elm.change(function() {
        const $this = $(this);
        this_func($this);
      });

      // テキストエリアに値を入力する関数
      function this_func($this){
        const $this_text = $("."+this_elm_name+"_text");
        const $this_textarea = $("."+this_elm_name+"_textarea");
        const $this_property = $("#"+this_elm_name+"_text");
        if($this.is(":checked")){
          $this_textarea.slideDown();
          $this_property.val($this_text.val());
        }
        else{
          $this_textarea.slideUp();
          $this_property.val("");
        }
      }
    }
    
  }

  // 商品ページ メッセージカードプレビュー表示
  {
    const $this_modal = $(".add_product_modal");

    // プレビューボタンクリックで表示
    $("#add_product_delivery_btn").click(function(){
      $this_modal.fadeIn();
    });

    // バツボタンクリックで非表示
    $(".add_product_modal__close").click(function(){
      console.log("クロース");
      $this_modal.fadeOut();
    });

    const $input_messege = $(".property_message_cart_text");

    // メッセージ入力でプレビュー反映
    $input_messege.on("input",function(){
      const $this = $(this);
      reflection_preview($this);
    }); 

    // ページ読み込み時にプレビュー反映
    $(window).on('load', function (){
      reflection_preview($input_messege);
    });

    // プレビュー反映する関数
    function reflection_preview($this){
      $(".add_product_modal__text").text($this.val());
    }
  }

  // 下層ページでtableタグをスクロールさせる関数（tableタグを.add_style_main__table-wrapperで囲う）
  {
    $('.add_style_main table').each(function() {
      $(this).wrap('<div class="add_style_main__table-wrapper"></div>');
    });
  }

// サイドバーの開閉
{
  // 既存（品種など）
  const $subtitleBtn = $(".add_sidebar_filter__subtitle_slide");

  $subtitleBtn.click(function(){
    const $this = $(this);
    const $content = $this.next(".add_sidebar_filter__subfilter");

    if($this.hasClass("add_sidebar_filter__subtitle_open")){
      $this.removeClass("add_sidebar_filter__subtitle_open");
      $content.slideUp();
    }
    else{
      $this.addClass("add_sidebar_filter__subtitle_open");
      $content.slideDown();
    }
  });

  // 追加（用途・サイズ・金額）
  const $titleBtn = $(".add_sidebar_filter__title");

  $titleBtn.click(function(){
    const $this = $(this);
    const $content = $this.parent().find(".add_sidebar_filter__subfilter").first();

    if($this.hasClass("add_sidebar_filter__subtitle_open")){
      $this.removeClass("add_sidebar_filter__subtitle_open");
      $content.slideUp();
    }
    else{
      $this.addClass("add_sidebar_filter__subtitle_open");
      $content.slideDown();
    }
  });
}


  // サイドバーの検索機能
  {
    let lastChecked;

    $('.add_sidebar_filter__check input[type=radio]').click(function() {
      const $radio = $(this);

      // チェックされている場合、チェックを解除する
      if ($radio.prop('checked') && $radio[0] === lastChecked) {
        setTimeout(function() {
          $radio.prop('checked', false);
          lastChecked = null;
          updateUrl(); // URLの更新処理を呼び出し
        }, 0);
      } else {
        lastChecked = $radio[0];
      }
    }).change(updateUrl); // changeイベントでURLを更新

    function updateUrl() {
      const sideVariety = $('input[name="side_variety"]:checked').val() || '';
      const sideUse = $('input[name="side_use"]:checked').val() || '';
      const sideSize = $('input[name="side_size"]:checked').val() || '';
      const sidePrice = $('input[name="side_price"]:checked').val() || '';

      const values = [sideVariety, sideUse, sideSize, sidePrice].filter(function(value) {
          return value !== '';
      });

      const newUrl = '/collections/all-products/?' + values.join('&');
      $('.sidebar_filter_btn').attr('href', newUrl);
    }
  }

  // 検索結果表示
  {
    // ローカルストレージリセット
    let filterTags = localStorage.getItem('add_filter_tags');
    let currentUrl = decodeURIComponent(window.location.href);
    if (!currentUrl.includes(filterTags)) {
      localStorage.setItem('add_filter', 'false');
      localStorage.removeItem('add_filter_tags');
    }


    // .sidebar_filter_btn クリック時の処理
    $('.sidebar_filter_btn').click(function(e) {
      localStorage.setItem('add_filter', 'true');
      let hrefParts = $(this).attr('href').split('/');
      let lastPart = hrefParts[hrefParts.length - 1];
      localStorage.setItem('add_filter_tags', lastPart);
    });

    // ページロード完了後の処理
    if (localStorage.getItem('add_filter') === 'true') {
      let filterTags = localStorage.getItem('add_filter_tags').replace(/\+/g, ',');
      $('#add_search_result').prepend('検索結果：' + filterTags + '<br>');
    }
  }

});